import { useSelector } from 'react-redux';
import { getCurrentUser } from '../../selectors/userSelectors';
import type { NavigationUser } from './navigationConfig';

/**
 * Thin, typed wrapper over getCurrentUser so the navigation feature can
 * consume the Redux state without touching the store's untyped shape
 * directly. Returns `undefined` before the user is loaded.
 */
export function useCurrentUser(): NavigationUser | undefined {
  return useSelector((state: unknown) =>
    getCurrentUser(state as never),
  ) as NavigationUser | undefined;
}
